export const ultimasNoticias = [
    {
        "imagen": "/assets/imgs/slide_programa.png",
        "url": "/pdf/Programa_Especial_Desarrollo_OM_2023_2028.pdf",
        "titulo": "",
        "fecha": "14 de mayo del 2024"
    }, 

  /*   {
        "imagen" : "./assets/imgs/image2.jpg",
         "titulo": "Reserva tu cancha en línea",
        "fecha": ""
    },    */

    
   /*  {
        "imagen": "/assets/imgs/convocatoria-cafe.jpg",
        "url": "/pdf/Convocatoria_Cafeteria.pdf",
        "titulo": "Arrendamiento para Espacio de Cafetería",
        "fecha": "02 de marzo del 2023"
    },  */
    /* {
        "imagen": "/assets/imgs/Transparencia.jpeg",
        "url": "/pdf/Convocatoria_2023.pdf",
        "titulo": "Transparencia en Corto",
        "fecha": "16 de mayo del 2023"
    }, */
   /*  {
        "imagen": "/assets/imgs/slide-conducta.png",
        "url": "/pdf/Codigo_Conducta_OM.pdf",
        "titulo": "Código de Conducta",
        "fecha": ""
    } */
]